import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "header" }

import { ref } from 'vue'
import HeaderAppBar from '@/components/ui/header/header-appBar.vue'
import headerNavDrawer from '@/components/ui/header/header-navDrawer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-header',
  setup(__props) {

const drawer = ref(false)

const navigationItems = [
  { title: 'Startsida', href: '/' },
  { title: 'Ärenden', href: '/case' },
  { title: 'Beslut & Tillstånd', href: '/permits' },
  { title: 'Ombud', href: '/delegate' },
  { title: 'Företagsuppgifter', href: '/companyinfo' },
  { title: 'Fastigheter', href: '/estates' }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderAppBar, {
      navigationItems: navigationItems,
      "onUpdate:navigationItems": _cache[0] || (_cache[0] = ($event: any) => ((navigationItems) = $event)),
      drawer: drawer.value,
      "onUpdate:drawer": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event))
    }, null, 8, ["drawer"]),
    _createVNode(headerNavDrawer, {
      navigationItems: navigationItems,
      "onUpdate:navigationItems": _cache[2] || (_cache[2] = ($event: any) => ((navigationItems) = $event)),
      drawer: drawer.value,
      "onUpdate:drawer": _cache[3] || (_cache[3] = ($event: any) => ((drawer).value = $event))
    }, null, 8, ["drawer"])
  ]))
}
}

})